import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccessPointFilterActvityComponent } from './access-point-filter-actvity.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserNameComponent } from './user-name/user-name.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { AccessPointActivityDetailComponent } from './access-point-activity-detail/access-point-activity-detail.component';
import { SharedLayoutModule } from 'src/app/shared-layout/shared-layout.module';
import { LockTypesComponent } from './lock-types/lock-types.component';
import { DateRangeComponent } from './date-range/date-range.component';
import { WithTooltipModule } from '../../with-tooltip/with-tooltip.module';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    AccessPointFilterActvityComponent,
    UserNameComponent,
    AccessPointActivityDetailComponent,
    LockTypesComponent,
    DateRangeComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    SharedLayoutModule,
    WithTooltipModule,
    TranslateModule,
    MatTooltipModule,
  ],
  exports: [AccessPointFilterActvityComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class AccessPointFilterActvityModule {}
